import { FunctionComponent, useCallback, useContext } from 'react'
import { WidgetProps } from '@rjsf/core'
import { Checkbox } from '@dxp-module/common'
import { FormContext } from '../../../../myInsurance/components/insuranceForm/InsuranceForm'
import disclaimerCheckboxStyles from './disclaimerCheckbox.styles'

const DisclaimerCheckboxWidget: FunctionComponent<WidgetProps> = props => {
  const { id, value, onChange, title, label } = props
  const { setLiveValidate } = useContext(FormContext)
  const styles = disclaimerCheckboxStyles({})

  const handleChange = useCallback(
    (newValue: boolean) => {
      onChange(newValue)
      setTimeout(() => setLiveValidate && setLiveValidate(true), 100)
    },
    [onChange, setLiveValidate]
  )

  return (
    <Checkbox
      id={id}
      label={title || label}
      onChange={handleChange}
      value={value}
      classes={styles}
      showLabel={false}
    />
  )
}

export default DisclaimerCheckboxWidget
